var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button } from 'antd';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { getRandomString } from '@sonar-software/sonar-ts-lib';
import { sonarHttpGet } from '@sonar-software/sonar-http';
import React, { useCallback, useState } from 'react';
function getAuthorizationEndpoint(oidcDomain) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const result = yield sonarHttpGet({
            skipSonarHeaders: true,
            targetUri: `${oidcDomain}/.well-known/openid-configuration`,
            uriType: 'absolute'
        });
        return (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.authorization_endpoint) !== null && _b !== void 0 ? _b : '';
    });
}
function getFullOidcRedirect(options) {
    const { origin } = window.location;
    const { oidcClientID, url } = options;
    const nonce = getRandomString(10);
    const state = getRandomString(10);
    return `${url}
			?client_id=${oidcClientID}
			&nonce=${nonce}
			&redirect_uri=${`${origin}${FULL_ROUTES.INTEGRATIONS_OIDC}`}
			&response_type=id_token
			&response_mode=fragment
			&scope=email openid profile
			&state=${state}`;
}
const OidcProviderNames = {
    azure: 'Azure',
    google: 'Google',
    none: 'None',
    okta: 'Okta',
    onelogin: 'OneLogin'
};
export const OidcProviderLoginButton = ({ config }) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const handleClick = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setIsProcessing(true);
        const endpoint = yield getAuthorizationEndpoint(config.oidcDomain);
        const redirectTarget = getFullOidcRedirect({
            oidcClientID: config.oidcClientID,
            url: endpoint
        });
        window.location.replace(redirectTarget);
    }), [config.oidcClientID, config.oidcDomain]);
    return (React.createElement("div", { id: 'oidc-provider' },
        React.createElement(Button, { loading: isProcessing, onClick: handleClick, type: 'primary' }, OidcProviderNames[config.provider])));
};
